/* ============================================================
   SMOOTH SCROLL — Lenis + GSAP ScrollTrigger
   Erahaus Shopify Theme for Scent of Qui
   ============================================================ */

(function () {
  'use strict';

  function initSmoothScroll() {
    if (document.body.classList.contains('template-product')) return;

    if (typeof Lenis === 'undefined' || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(initSmoothScroll, 80);
      return;
    }

    const lenis = new Lenis({
      duration:        1.2,
      easing:          function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel:     true,
      wheelMultiplier: 0.8,
      touchMultiplier: 1.0,
    });

    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add(function (time) {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    window.__lenis = lenis;

    /* ── Controlled section chain: Section 3 → 4 → (5) → Footer ─ */
    /*                                                               */
    /* Capture-phase listener fires before Lenis's bubble handler.  */
    /* e.stopPropagation() prevents Lenis from accumulating delta    */
    /* while inside any locked zone.                                 */
    /*                                                               */
    /* Navigation map:                                               */
    /*   Sec 3 ↑  → natural exit to Section 2 (Lenis)               */
    /*   Sec 3 ↓  → Sec 4   (threshold: WHEEL_THRESH)               */
    /*   Sec 4 ↑  → Sec 3   (threshold: WHEEL_THRESH)               */
    /*   Sec 4 ↓  → Sec 5 if exists (threshold), else Footer (imm.) */
    /*   Sec 5 ↑  → Sec 4   (immediate)                             */
    /*   Sec 5 ↓  → Footer  (immediate)                             */
    /*   Footer ↑ → Sec 5 if exists, else Sec 4 (immediate)         */
    /*   Footer ↓ → blocked (final destination)                     */

    var sec3   = document.querySelector('.js-collection-statement');
    var sec4   = document.querySelector('.js-collection-video');
    var sec5   = document.querySelector('.js-creators');
    var footer = document.querySelector('.js-site-footer');

    if (!sec3 || !sec4) return;

    var snapLocked   = false;
    var wheelAccum   = 0;
    var WHEEL_THRESH = 100;
    var inSnapZone   = false;

    function doSnap(target) {
      snapLocked  = true;
      inSnapZone  = true;
      wheelAccum  = 0;
      lenis.stop();
      var startY  = window.scrollY;
      var targetY = Math.round(startY + target.getBoundingClientRect().top);
      var dur     = 1200;
      var began   = performance.now();
      function ease(t) { return -(Math.cos(Math.PI * t) - 1) / 2; }
      function tick(now) {
        var t = Math.min((now - began) / dur, 1);
        window.scrollTo(0, startY + (targetY - startY) * ease(t));
        ScrollTrigger.update();
        if (t < 1) {
          requestAnimationFrame(tick);
        } else {
          window.scrollTo(0, targetY);
          ScrollTrigger.update();
          lenis.scrollTo(targetY, { immediate: true });
          lenis.start();
          setTimeout(function () { snapLocked = false; }, 80);
        }
      }
      requestAnimationFrame(tick);
    }

    window.addEventListener('wheel', function (e) {

      /* Block everything while a snap animation is in flight */
      if (snapLocked) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      var s3t = sec3.getBoundingClientRect().top;
      var s4t = sec4.getBoundingClientRect().top;
      var s4b = sec4.getBoundingClientRect().bottom;
      var s5t = sec5   ? sec5.getBoundingClientRect().top   : Infinity;
      var ft  = footer ? footer.getBoundingClientRect().top : Infinity;

      var inSec3       = s3t <= 0 && s4t > 0;
      var inSec4       = s4t <= 0 && s4b > 0 && s3t < 0;
      var inSec5       = !!(sec5   && s5t <= 0 && ft  > 0);
      var inFooterZone = !!(footer && ft  <= 0);
      var nowInZone    = inSec3 || inSec4 || inSec5 || inFooterZone;

      /* Outside every locked zone — release and let Lenis run */
      if (!nowInZone) {
        wheelAccum = 0;
        if (inSnapZone) { inSnapZone = false; lenis.start(); }
        return;
      }

      /* Section 3 upward → natural exit toward Section 2 */
      if (inSec3 && e.deltaY < 0) {
        inSnapZone = false; wheelAccum = 0; lenis.start();
        return; /* no stopPropagation — Lenis carries this scroll */
      }

      /* All other locked-zone events: intercept before Lenis */
      e.preventDefault();
      e.stopPropagation();

      /* Zone entry: freeze Lenis inertia at current position */
      if (!inSnapZone) {
        inSnapZone = true;
        lenis.stop();
        lenis.scrollTo(window.scrollY, { immediate: true });
      }

      /* Direction reversal resets accumulator */
      var dSign = e.deltaY > 0 ? 1 : e.deltaY < 0 ? -1 : 0;
      var aSign = wheelAccum > 0 ? 1 : wheelAccum < 0 ? -1 : 0;
      if (dSign !== 0 && aSign !== 0 && dSign !== aSign) wheelAccum = 0;
      wheelAccum += e.deltaY;

      /* ── Section 3 ↔ 4 (accumulator threshold) ─────────────── */
      if (inSec3 && wheelAccum >  WHEEL_THRESH) { doSnap(sec4); return; }
      if (inSec4 && wheelAccum < -WHEEL_THRESH) { doSnap(sec3); return; }

      /* ── Section 4 ↓ (accumulator threshold when Sec 5 exists) */
      if (inSec4 && sec5 && wheelAccum > WHEEL_THRESH) { doSnap(sec5); return; }

      /* ── Section 4 ↓ Footer (immediate — no Sec 5 yet) ──────── */
      if (inSec4 && !sec5 && footer && e.deltaY > 0) { doSnap(footer); return; }

      /* ── Section 5 ↓ Footer (immediate) ─────────────────────── */
      if (inSec5 && footer && e.deltaY > 0) { doSnap(footer); return; }

      /* ── Section 5 ↑ Section 4 (immediate) ──────────────────── */
      if (inSec5 && e.deltaY < 0) { doSnap(sec4); return; }

      /* ── Footer ↑ previous section (immediate) ───────────────── */
      if (inFooterZone && e.deltaY < 0) { doSnap(sec5 || sec4); return; }

      /* ── Footer ↓ blocked — final destination ────────────────── */

    }, { passive: false, capture: true });

    /* ── Touch snap — mirrors wheel logic for mobile/touch ──────── */

    var touchStartY  = 0;
    var touchFired   = false;
    var TOUCH_THRESH = 50; /* px of finger travel before snap fires */

    window.addEventListener('touchstart', function (e) {
      touchStartY = e.touches[0].clientY;
      touchFired  = false;
    }, { passive: true, capture: true });

    window.addEventListener('touchmove', function (e) {

      /* Block all touch input while a snap animation is in flight */
      if (snapLocked) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      var deltaY = touchStartY - e.touches[0].clientY; /* +ve = finger moved up = scroll down */

      var ts3t = sec3.getBoundingClientRect().top;
      var ts4t = sec4.getBoundingClientRect().top;
      var ts4b = sec4.getBoundingClientRect().bottom;
      var ts5t = sec5   ? sec5.getBoundingClientRect().top   : Infinity;
      var tft  = footer ? footer.getBoundingClientRect().top : Infinity;

      var tInSec3       = ts3t <= 0 && ts4t > 0;
      var tInSec4       = ts4t <= 0 && ts4b > 0 && ts3t < 0;
      var tInSec5       = !!(sec5   && ts5t <= 0 && tft  > 0);
      var tInFooterZone = !!(footer && tft  <= 0);
      var tNowInZone    = tInSec3 || tInSec4 || tInSec5 || tInFooterZone;

      /* Outside locked zone — let Lenis handle freely */
      if (!tNowInZone) {
        if (inSnapZone) { inSnapZone = false; lenis.start(); }
        return;
      }

      /* Section 3 swipe up → natural exit toward Section 2 */
      if (tInSec3 && deltaY < 0) {
        inSnapZone = false; lenis.start();
        return;
      }

      /* Inside snap zone — intercept before Lenis accumulates delta */
      e.preventDefault();
      e.stopPropagation();

      /* Zone entry: snap active section top to viewport, kill momentum */
      if (!inSnapZone) {
        inSnapZone   = true;
        var tActive  = tInSec3 ? sec3 : tInSec4 ? sec4 : tInSec5 ? sec5 : footer;
        var tOffset  = tActive.getBoundingClientRect().top;
        var tAligned = Math.round(window.scrollY + tOffset);
        lenis.stop();
        if (Math.abs(tOffset) > 1) { window.scrollTo(0, tAligned); ScrollTrigger.update(); }
        lenis.scrollTo(tAligned, { immediate: true });
      }

      /* One snap per gesture; wait for minimum travel */
      if (touchFired || Math.abs(deltaY) < TOUCH_THRESH) return;
      touchFired = true;

      if (tInSec3 && deltaY >  0)                    { doSnap(sec4);         return; }
      if (tInSec4 && deltaY <  0)                    { doSnap(sec3);         return; }
      if (tInSec4 && !sec5 && footer && deltaY > 0)  { doSnap(footer);       return; }
      if (tInSec4 && sec5  && deltaY >  0)           { doSnap(sec5);         return; }
      if (tInSec5 && footer && deltaY >  0)          { doSnap(footer);       return; }
      if (tInSec5 && deltaY <  0)                    { doSnap(sec4);         return; }
      if (tInFooterZone && deltaY <  0)              { doSnap(sec5 || sec4); return; }

    }, { passive: false, capture: true });

    window.addEventListener('touchend', function () {
      touchFired = false;
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmoothScroll);
  } else {
    initSmoothScroll();
  }

})();
